import { render, staticRenderFns } from "./BsiContinuousFilingApplications.vue?vue&type=template&id=8313132e&scoped=true&"
import script from "./BsiContinuousFilingApplications.vue?vue&type=script&lang=js&"
export * from "./BsiContinuousFilingApplications.vue?vue&type=script&lang=js&"
import style0 from "./BsiContinuousFilingApplications.vue?vue&type=style&index=0&id=8313132e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8313132e",
  null
  
)

export default component.exports